/* Outdoors Nordic - marknadsvaljarens panel (on-market-selector och
   dropdown-delegation). Den lata klonen till desktopluckan ligger kvar inline i
   snippeten: oppnas valjaren innan modulen kort maste luckan anda fyllas, annars
   ar panelen tom och Horizons localization.js kastar (matt 2026-10-12). Flyttad ur snippets/on-market-selector-panel.liquid
   (rad 50, 2026-10-12). Laddas som type="module" eftersom snippeten renderas
   upp till tre ganger: en modul med samma adress kor exakt en gang.
   Betalmetoderna per marknad ligger kvar inline som window.__onMsPay. Tidiga
   klick pa landslistan fangas av klickbryggan. */
(function () {
  if (customElements.get('on-market-selector')) return;
  var CARRIERS = {
    SE:['postnord'], NO:['bring'], DK:['dao'], FI:['posti'], AT:['austrianpost'],
    CH:['swisspost'], NL:['postnl'], BE:['bpost'], GB:['royalmail'], UK:['royalmail']
  };
  var CB = 'https://cdn.shopify.com/s/files/1/0660/8496/2528/files/';
  var META = {
    postnord:[CB+'postnord_d371cd30-1e6a-4c86-adaf-1bdd6b451142.svg?v=1777912207','PostNord'],
    bring:[CB+'bring_98b3fad6-449d-4f8a-8c76-e3e167cbad1a.svg?v=1777912207','Bring'],
    dao:[CB+'dao_5d8ebf89-9744-4767-9b02-ffde8edde3c8.svg?v=1777912207','DAO'],
    posti:[CB+'posti_4dd6aa15-821f-42a3-8b6e-0f4b60631cab.svg?v=1777910964','Posti'],
    postnl:[CB+'postnl_c337e624-e393-4abf-bc98-efab4dc9898f.svg?v=1777910965','PostNL'],
    royalmail:[CB+'royalmail.svg?v=1777910965','Royal Mail'],
    bpost:[CB+'bpost-be.svg?v=1778620029','bpost'],
    swisspost:[CB+'swisspost.svg?v=1777910965','Swiss Post'],
    austrianpost:[CB+'austrianpost.svg?v=1777910965','Österreichische Post'],
    dhl:[CB+'dhl_c09ae7ca-03a2-4d05-92cd-0f47a469a16e.svg?v=1777910965','DHL']
  };
  var PRIMLANG = {
    SE:'sv', NO:'nb', DK:'da', FI:'fi', DE:'de', AT:'de', CH:'de', NL:'nl', BE:'nl',
    GB:'en', UK:'en', US:'en', CA:'en', FR:'fr', IT:'it', ES:'es', PL:'pl', PT:'pt'
  };
  /* Betalmetoder per marknad. Byggs i Liquid ur on-pay-methods och ligger
     kvar inline i snippeten som window.__onMsPay. */
  function payFor(cc) {
    var pm = window.__onMsPay || {};
    return pm[cc] || pm.DEFAULT || [];
  }

  class OnMarketSelector extends HTMLElement {
    /* No-op:er så Horizons dropdown-localization-component (som anropar
       refs.localizationForm.focusSearchInput()/resetForm()) inte kraschar
       när vår panel ersätter native-formuläret i headern. */
    focusSearchInput() {}
    resetForm() {}
    connectedCallback() {
      this.country = this.querySelector('[data-ms-country]');
      if (!this.country) return;
      if (this._msBound) return;
      this._msBound = true;
      this.deliver = this.querySelector('[data-ms-deliver]');
      this.currency = this.querySelector('[data-ms-currency]');
      this.langSel = this.querySelector('[data-ms-lang]');
      this.payWrap = this.querySelector('[data-ms-pay]');
      this.dd = this.querySelector('[data-ms-dd]');
      this.ddTrigger = this.querySelector('[data-ms-dd-trigger]');
      this.ddList = this.querySelector('[data-ms-dd-list]');
      this.triggerFlag = this.querySelector('[data-ms-flag]');
      this.triggerLabel = this.querySelector('[data-ms-dd-label]');
      this.applyPay((this.country.value || '').toUpperCase());
    }
    toggleDd() { if (!this.ddList) return; if (this.ddList.hidden) this.openDd(); else this.closeDd(); }
    openDd() {
      if (!this.ddList) return;
      this.ddList.hidden = false;
      if (this.ddTrigger) this.ddTrigger.setAttribute('aria-expanded', 'true');
      if (this.dd) this.dd.classList.add('is-open');
      var act = this.ddList.querySelector('.on-ms__dd-opt.is-active');
      if (act && act.scrollIntoView) act.scrollIntoView({ block: 'nearest' });
    }
    closeDd() {
      if (!this.ddList) return;
      this.ddList.hidden = true;
      if (this.ddTrigger) this.ddTrigger.setAttribute('aria-expanded', 'false');
      if (this.dd) this.dd.classList.remove('is-open');
    }
    applyPay(cc) {
      if (!this.payWrap) return;
      var want = payFor(cc);
      var wrap = this.payWrap;
      wrap.querySelectorAll('[data-pay]').forEach(function (el) { el.hidden = true; });
      for (var i = want.length - 1; i >= 0; i--) {
        var el = wrap.querySelector('[data-pay="' + want[i] + '"]');
        if (el) { el.hidden = false; wrap.insertBefore(el, wrap.firstChild); }
      }
    }
    selectCountry(opt) {
      var cc = opt.getAttribute('data-iso') || '';
      if (this.country) this.country.value = cc;
      var flag = opt.querySelector('.on-ms__dd-flag');
      if (this.triggerFlag && flag) this.triggerFlag.innerHTML = flag.innerHTML;
      var name = opt.querySelector('.on-ms__dd-name');
      if (this.triggerLabel && name) this.triggerLabel.textContent = name.textContent;
      this.ddList.querySelectorAll('[data-ms-dd-opt]').forEach(function (b) {
        var on = b === opt;
        b.classList.toggle('is-active', on);
        var li = b.closest('[role="option"]'); if (li) li.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.applyCountry(cc.toUpperCase(), opt.getAttribute('data-cur') || '', opt.getAttribute('data-sym') || '');
      this.closeDd();
    }
    applyCountry(cc, cur, sym) {
      if (this.currency) this.currency.textContent = sym ? (cur + ' · ' + sym) : cur;
      if (this.deliver) {
        var list = CARRIERS[cc] || ['dhl'];
        this.deliver.innerHTML = list.map(function (h) {
          var m = META[h] || META.dhl;
          return '<img class="on-carrier-logo" src="' + m[0] + '" alt="' + m[1] + '" loading="lazy" height="34" width="64">';
        }).join('');
      }
      this.applyPay(cc);
      if (this.langSel) {
        var want = PRIMLANG[cc];
        if (want) {
          for (var i = 0; i < this.langSel.options.length; i++) {
            var iso = (this.langSel.options[i].value || '').toLowerCase().split('-')[0];
            if (iso === want) { this.langSel.selectedIndex = i; break; }
          }
        }
      }
    }
  }
  customElements.define('on-market-selector', OnMarketSelector);

  /* Document-delegation för landsdropdownen – oberoende av custom-elementets
     livscykel (popover-panelen i mobil-headern hinner inte alltid initieras).
     Körs en gång; funkar för footer, desktop-header OCH mobil-popover. */
  if (!window.__onMsDeleg) {
    window.__onMsDeleg = true;
    document.addEventListener('click', function (e) {
      var trig = e.target.closest('[data-ms-dd-trigger]');
      if (trig) {
        e.preventDefault();
        var host = trig.closest('on-market-selector');
        var dd = trig.closest('[data-ms-dd]');
        var list = dd && dd.querySelector('[data-ms-dd-list]');
        if (!list) return;
        if (host && typeof host.toggleDd === 'function') { host.toggleDd(); }
        else { var willOpen = list.hidden; list.hidden = !willOpen; trig.setAttribute('aria-expanded', willOpen ? 'true' : 'false'); if (dd) dd.classList.toggle('is-open', willOpen); }
        return;
      }
      var opt = e.target.closest('[data-ms-dd-opt]');
      if (opt) {
        e.preventDefault();
        var host2 = opt.closest('on-market-selector');
        if (host2 && typeof host2.selectCountry === 'function') { host2.selectCountry(opt); return; }
        var dd2 = opt.closest('[data-ms-dd]');
        if (!dd2) return;
        var input = dd2.querySelector('[data-ms-country]'); if (input) input.value = opt.getAttribute('data-iso') || '';
        var lbl = dd2.querySelector('[data-ms-dd-label]'); var nm = opt.querySelector('.on-ms__dd-name'); if (lbl && nm) lbl.textContent = nm.textContent;
        var tflag = dd2.querySelector('[data-ms-flag]'); var oflag = opt.querySelector('.on-ms__dd-flag'); if (tflag && oflag) tflag.innerHTML = oflag.innerHTML;
        dd2.querySelectorAll('[data-ms-dd-opt]').forEach(function (b) { b.classList.toggle('is-active', b === opt); });
        var l2 = dd2.querySelector('[data-ms-dd-list]'); if (l2) l2.hidden = true; dd2.classList.remove('is-open');
        return;
      }
      var openDds = document.querySelectorAll('[data-ms-dd].is-open');
      for (var i = 0; i < openDds.length; i++) {
        if (!openDds[i].contains(e.target)) { var ll = openDds[i].querySelector('[data-ms-dd-list]'); if (ll) ll.hidden = true; openDds[i].classList.remove('is-open'); }
      }
    }, true);
  }
})();
